import { Box, Tab, Typography } from "@mui/material";
import {
  ICarriersTabProps,
  IOrdersTabs,
  IOwnFleetTabProps,
  TTabKey,
} from "../../../interfaces/order";
import {
  CARRIERS_TAB_ID,
  ORDERS_TABS,
  OWN_FLEET,
  OWN_FLEET_TAB_ID,
} from "../../../utils/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import React, { SyntheticEvent, useEffect, useState } from "react";
import CarriersTab from "./CarriersTab";
import OwnFleetTab from "./OwnFleetTab";
import BulkOwnFleetOrderStatusUpdate from "../BulkOwnFleetOrderStatusUpdate";

const OrdersTabs = ({
  showTitle,
  tabProps,
  tabsToShow,
  handleChangeFilter,
}: IOrdersTabs) => {
  const [tabValue, setTabValue] = useState(CARRIERS_TAB_ID);
  const [showBulkUpdate, setShowBulkUpdate] = useState(false);
  const handleChange = (_event: SyntheticEvent, newTabValue: string) => {
    setTabValue(newTabValue);
  };

  const resetAllFilters = () => {
    const keysToReset: [string, null | undefined][] = [
      ["fromDate", null],
      ["toDate", null],
      ["tracking_id", undefined],
      ["status", undefined],
      ["_id", undefined],
      ["merchantId", undefined],
      ["sort", undefined],
      ["search", undefined],
      ["carrier", undefined]
    ];
    keysToReset.forEach(([key, value]) => handleChangeFilter(key, value));
  };

  const tabs: { [key: string]: (_props: any) => React.ReactElement } = {
    [CARRIERS_TAB_ID]: (props: ICarriersTabProps) => <CarriersTab {...props} />,
    [OWN_FLEET_TAB_ID]: (props: IOwnFleetTabProps) => (
      <OwnFleetTab {...props} showBulkUpdate={showBulkUpdate} setShowBulkUpdate={setShowBulkUpdate} />
    ),
  };

  // Only show the tabs that are included in tabsToShow array. This is needed because this component is used in two different sections of the dashboard and we need a quick way to get control over this without refactoring.
  // This is a PROVISIONAL change and its refactor is pending.
  const filteredTabs = ORDERS_TABS.filter(({ id }) => tabsToShow.includes(id));

  useEffect(() => {
    resetAllFilters();
    handleChangeFilter(
      "carrier",
      tabValue === OWN_FLEET_TAB_ID ? OWN_FLEET : undefined
    );
  }, [tabValue]);

  return (
    <>
      {showBulkUpdate ? (
        <BulkOwnFleetOrderStatusUpdate onBackClick={() => setShowBulkUpdate(false)} />
      ) : (
        <>
          {showTitle && <Typography className="f-s-20">Órdenes</Typography>}
          <TabContext value={tabValue}>
            <Box
              className="m-t-20"
              sx={{ borderBottom: 1, borderColor: "divider", width: "fit-content" }}
            >
              {filteredTabs.length > 0 && (
                <TabList onChange={handleChange}>
                  {filteredTabs.map(
                    ({ id, label }: { id: TTabKey; label: string }) => (
                      <Tab key={id} label={label} value={id} />
                    )
                  )}
                </TabList>
              )}
            </Box>
            {ORDERS_TABS.map(({ id }: { id: TTabKey; label: string }) => (
              <TabPanel key={id} value={id}>
                {tabs[id](tabProps[id])}
              </TabPanel>
            ))}
          </TabContext>
        </>
      )}
    </>
  );
};

export default OrdersTabs;
